import styled from "styled-components";

export const DashbaordAreaChartWrapper = styled.div`
  
`;
